module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG1f78f60f538239217bceee4992a43930.1f78f60f.png";